import { DisplayColumn } from './report-display-column';
import { SelectItem } from './select-item';
import { Operator } from './report-operators';
import { FilterGroup } from './filter-group';
import { OrderColumn } from './report-order-column';

export class ReportDetails {
    public id?: number;
    public orderDirections: Array<SelectItem>;
    public aggregateColumnTypes: Array<SelectItem>;
    public booleanValues: Array<SelectItem>;
    public operators: Array<Operator>;
    public logicalOperators: Array<SelectItem>;
    public displayColumns: Array<DisplayColumn>;
    public orderColumns: Array<OrderColumn>;
    public filterGroups: Array<FilterGroup>;
    public columns: Array<DisplayColumn>;
    public groups: Array<SelectItem>;
    public deleted: boolean;
    public canEdit: boolean;
    public editGroupId?: number;
    public editUserId?: number;
    public isSystem: boolean;
    public groupId?: number;
    public resultsPerPage: number;
    public description: string;
    public name: string;
    public createdBy: number;
    public selectedTags: Array<string>;

    constructor(data: any) {
        this.id = data.id;
        this.orderDirections = data.orderDirections;
        this.aggregateColumnTypes = data.aggregateColumnTypes;
        this.booleanValues = data.booleanValues;
        this.operators = data.operators;
        this.logicalOperators = data.logicalOperators;
        this.displayColumns = data.displayColumns;
        this.filterGroups = data.filterGroups;
        this.columns = data.columns;
        this.groups = data.groups;
        this.deleted = data.deleted;
        this.canEdit = data.canEdit;
        this.editGroupId = data.editGroupId;
        this.editUserId = data.editUserId;
        this.isSystem = data.isSystem;
        this.groupId = data.groupId;
        this.resultsPerPage = data.resultsPerPage;
        this.description = data.description;
        this.name = data.name;
        this.createdBy = data.createdBy;
        this.selectedTags = data.selectedTags;
    }
}
